import { useMemo } from "react";
import { useAccrualVsCashComparison } from "@/hooks/queries/useAccrualVsCashComparison";
import { useCreancesByParty } from "@/hooks/queries/useCreancesByParty";
import { useOpenEngagements } from "@/hooks/queries/useOpenEngagements";

interface CreancesEngagementsAnalyticsParams {
  from: string;
  to: string;
}

export function useCreancesEngagementsAnalytics({
  from,
  to,
}: CreancesEngagementsAnalyticsParams) {
  const params = useMemo(() => ({ from, to }), [from, to]);
  const { data: creances = [], isLoading: loadingCreances } = useCreancesByParty();
  const { data: comparison, isLoading: loadingComparison } =
    useAccrualVsCashComparison(params);
  const { data: engagements, isLoading: loadingEngagements } = useOpenEngagements();

  return {
    creances,
    comparison,
    engagements,
    loading: loadingCreances || loadingComparison || loadingEngagements,
  };
}
